/**
 * @项目名称: work
 * @功能名称:
 * @文件名称: utils
 * @Date: 2019/11/22
 * @Author: liux
 * @Copyright（C）2019 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */
import {extend} from '../helper/utils'
export default class utils {
  createUniqueString () {
    const timestamp = +new Date() + ''
    const randomNum = parseInt((1 + Math.random()) * 65536) + ''
    return (+(randomNum + timestamp)).toString(32).toUpperCase()
  }
  getCurrentTime () {
    return new Date().getTime()
  }
  getCookieId () {
    var id = ''
    try {
      id = localStorage.getItem('reportCookieId')
      if (!id) {
        id = this.createUniqueString()
        localStorage.setItem('reportCookieId', id)
      }
    } catch (e) {
      return this.createUniqueString()
    }
    return id
  }
  getVisitId () {
    var id = ''
    try {
      id = localStorage.getItem('reportVisitId')
      if (!id) {
        id = this.createUniqueString()
        localStorage.setItem('reportVisitId', id)
      }
    } catch (e) {
      return this.createUniqueString()
    }
    return id
  }
  query (key, search = '') {
    if (!search) {
      search = window.location.search
    }
    var m = search.match(new RegExp('(\\?|&)' + key + '=([^&]*)(&|$)'))
    return !m ? '' : decodeURIComponent(m[2])
  }

  readXPath (element) {
    if (!element) {
      return ''
    }
    if (element.id !== '') {
      // 判断id属性，如果这个元素有id，则显 示//*[@id="xPath"]  形式内容
      return '//*[@id="' + element.id + '"]'
    }
    // 这里需要需要主要字符串转译问题，可参考js 动态生成html时字符串和变量转译（注意引号的作用）
    if (element === document.body) {
      // 递归到body处，结束递归
      return '/html/' + element.tagName.toLowerCase()
    }
    let ix = 1 // 在nodelist中的位置，且每次点击初始化
    const siblings = (element.parentNode && element.parentNode.childNodes) || [] // 同级的子元素

    for (let i = 0, l = siblings.length; i < l; i++) {
      const sibling = siblings[i]
      // 如果这个元素是siblings数组中的元素，则执行递归操作
      if (sibling === element) {
        return (
          this.readXPath(element.parentNode) +
          '/' +
          element.tagName.toLowerCase() +
          '[' +
          ix +
          ']'
        )
        // 如果不符合，判断是否是element元素，并且是否是相同元素，如果是相同的就开始累加
      } else if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
        ix++
      }
    }
    return ''
  }

  filterObj(obj, options = [{
        source: 'select',
        target: 's-elect'
       },
       {
        source: 'SELECT',
        target: 'S-ELECT'
       }]) {
        let objStr = JSON.stringify(obj)
        for (let index in options) {
            if (objStr.includes(options[index].source)) {
              const reg = new RegExp(options[index].source, 'g')
              objStr = objStr.replace(reg, options[index].target)
            }
          }
        return JSON.parse(objStr)
     }

  extend(){
    return extend(...arguments)
  }
}
